// src/components/hooks/usePayment.js
import { useCallback } from 'react';
import axios from 'axios';

export const usePayment = () => {
    
    // Aggiorna lo sconto nel database (prima del pagamento)
    const updateDiscount = useCallback(async (orderId, discountData) => {
        try {
            console.log('💰 Aggiornamento sconto per ordine:', orderId, discountData);
            
            // ✅ Aggiunto /api/
            const response = await axios.put(`/api/orders/${orderId}/payment-status`, {
                paymentStatus: 'pending',
                transactionId: null,
                scontoSpedizione: discountData.scontoSpedizione,
                scontoTipo: discountData.scontoTipo,
                importoTotale: discountData.importoTotale,
                costoSpedizione: discountData.costoSpedizione,
                importoIva: discountData.importoIva
            });
            
            // ✅ Corretto: response.status invece di response.ok
            if (response.status !== 200) throw new Error('Errore aggiornamento sconto');
            // ✅ Corretto: response.data invece di response.json()
            return response.data;
        } catch (error) {
            console.error('❌ Errore updateDiscount:', error);
            throw error;
        }
    }, []);

    // ✅ Conferma pagamento (DOPO pagamento riuscito) - AGGIORNA stato a 'pagato'
    const confirmPayment = useCallback(async (orderId, transactionId, paymentMethod, discountData = {}) => {
        try {
            console.log('💰 Conferma pagamento per ordine:', orderId);
            console.log('💳 Metodo:', paymentMethod);
            console.log('🆔 Transaction ID:', transactionId);
            
            // ✅ Aggiunto /api/
            const response = await axios.put(`/api/orders/${orderId}/payment-status`, {
                paymentStatus: 'success',
                transactionId: transactionId,
                metodo_pagamento: paymentMethod,
                scontoSpedizione: discountData.scontoSpedizione,
                scontoTipo: discountData.scontoTipo,
                importoTotale: discountData.importoTotale,
                costoSpedizione: discountData.costoSpedizione,
                importoIva: discountData.importoIva
            });
            
            // ✅ Corretto
            if (response.status !== 200) throw new Error('Errore conferma pagamento');
            // ✅ Corretto
            const result = response.data;
            console.log('✅ Pagamento confermato nel DB:', result);
            return result;
        } catch (error) {
            console.error('❌ Errore confirmPayment:', error);
            throw error;
        }
    }, []);

    // Salva ordine nel sessionStorage
    const saveOrderToSession = useCallback((updatedOrder, orderId, discount) => {
        sessionStorage.setItem('pendingOrder', JSON.stringify({
            order: updatedOrder,
            orderId: orderId,
            sconto: discount
        }));
        
        sessionStorage.setItem('orderData', JSON.stringify({
            order: updatedOrder,
            paymentMethod: 'card',
            success: true
        }));
        console.log('✅ Ordine salvato in sessionStorage');
        // ✅ VERIFICA IMMEDIATAMENTE SE È STATO SALVATO
        console.log('🔍 VERIFICA sessionStorage DOPO salvataggio:');
        console.log('  orderData:', sessionStorage.getItem('orderData'));
        console.log('  pendingOrder:', sessionStorage.getItem('pendingOrder'));
    }, []);

    // Prepara l'ordine aggiornato con sconto
    const prepareDiscountedOrder = useCallback((originalOrder, shippingDiscount, updatedTotals, totaleIva) => {
        return {
            ...originalOrder,
            costo_spedizione: updatedTotals.shippingCost,
            importo_totale: updatedTotals.discountedTotal,
            sconto_spedizione: shippingDiscount.discount,
            sconto_tipo: shippingDiscount.isAbruzzo ? 'abruzzo_50' : null,
            importo_iva: totaleIva
        };
    }, []);

    return {
        updateDiscount,
        confirmPayment,
        saveOrderToSession,
        prepareDiscountedOrder
    };
};